import React, { Component } from 'react'
import { Link } from 'react-router-dom'


export default class MenuD extends Component {

    state = { opa : 1 }

    opaFx = () => {

        if(this.state.opa === 1) {
        
            this.setState({ opa : 0.3 })

        } else {

            this.setState({ opa : 1 })

        }
    }


    render() {

        return (

            <div className='MenuContainer' style={{opacity: this.state.opa}}>

                <div id='MenuEye'><i className='material-icons' onClick={this.opaFx}>visibility</i></div>

                <div id='MenuMenu'>

                    <Link to='/'><i className='material-icons'>home</i><span>Home</span></Link>
                    <Link to='/memo'><i className='material-icons'>list_alt</i><span>Memo</span></Link>
                    <Link to='/docs'><i className='material-icons'>archive</i><span>Docs</span></Link>
                    <Link to='/secret'><i className='material-icons'>lock</i><span>Keys</span></Link>
	                <Link to='/type'><i className='material-icons'>keyboard</i><span>Typing</span></Link>
                    <Link to='/mustom'><i className='material-icons'>shopping_cart</i><span>Mustom</span></Link>
                    <Link to='/flashcard'><i className='material-icons'>translate</i><span>Fcard</span></Link>
                    <Link to='/peace'><i className='material-icons'>hot_tub</i><span>Peace</span></Link>
                    <Link to='/movie'><i className='material-icons'>movie</i><span>Movie</span></Link>
                    <Link to='/calendar'><i className='material-icons'>today</i><span>Days</span></Link>
                    <Link to='/share'><i className='material-icons'>cloud_upload</i><span>Share</span></Link>
                    <Link to='/sticky'><i className='material-icons'>widgets</i><span>Note</span></Link>
                    <Link to='/plan'><i className='material-icons'>explore</i><span>Plan</span></Link>
                    <Link to='/about'><i className='material-icons'>face</i><span>About</span></Link>
                    	
                </div>

            </div>
        )
    }
}

   


// WEBPACK FOOTER //
// ./src/components/menu/MenuD.js